import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { DialogFormsStore } from './types';

const useDialogFormsStore = create<DialogFormsStore>()(
  devtools(
    set => ({
      displayFundDialogForm: false,
      displayFundInvestmentDialogForm: false,
      shouldUpdateFund: false,
      shouldUpdateFundInvestment: false,
      setDisplayFundDialogForm: displayFundDialogForm => set(() => ({ displayFundDialogForm })),
      setDisplayFundInvestmentDialogForm: displayFundInvestmentDialogForm =>
        set(() => ({ displayFundInvestmentDialogForm })),
      setShouldUpdateFund: shouldUpdateFund => set(() => ({ shouldUpdateFund })),
      setShouldUpdateFundInvestment: shouldUpdateFundInvestment => set(() => ({ shouldUpdateFundInvestment })),
    }),
    {
      name: 'DialogFormsStore',
    }
  )
);

export default useDialogFormsStore;
